/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper,
  IconButton, TablePagination, Chip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const situacaoColor = (situacao) => {
  switch (situacao) {
    case 'ativo': return 'success';
    case 'futuro': return 'warning';
    case 'expirado': return 'error';
    default: return 'default';
  }
};

const situacaoLabel = (situacao) => {
  switch (situacao) {
    case 'ativo': return 'Ativo';
    case 'futuro': return 'Futuro';
    case 'expirado': return 'Expirado';
    default: return 'Inativo';
  }
};

const formatDate = (value) => {
  if (!value) return 'Indeterminado';
  const onlyDate = String(value).split('T')[0];
  const [y, m, d] = onlyDate.split('-');
  return y && m && d ? `${d}/${m}/${y}` : onlyDate;
};

function AcessoLiberadoList({ refresh, onEdit, onChanged, search, imovelId, pessoaId, showAll }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchItems = () => {
    let url = `/acessos-liberados?page=${page}&limit=${rowsPerPage}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (imovelId) url += `&imovelId=${imovelId}`;
    if (pessoaId) url += `&pessoaId=${pessoaId}`;
    if (showAll) url += `&showAll=true`;

    api.get(url)
      .then((response) => {
        setItems(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => console.error('Erro ao buscar acessos liberados:', error));
  };

  useEffect(() => {
    fetchItems();
  }, [refresh, page, rowsPerPage, search, imovelId, pessoaId, showAll]);

  useEffect(() => {
    setPage(0);
  }, [search, imovelId, pessoaId, showAll]);

  const handleInativar = async (id) => {
    if (!window.confirm('Tem certeza que deseja inativar este acesso liberado?')) return;
    try {
      await api.delete(`/acessos-liberados/${id}`);
      onChanged();
      fetchItems();
    } catch (error) {
      console.error('Erro ao inativar acesso liberado:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 800 }} aria-label="acessos liberados table">
          <TableHead>
            <TableRow>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Unidade</TableCell>
              <TableCell>Pessoa</TableCell>
              <TableCell>Documento</TableCell>
              <TableCell>Autorizador</TableCell>
              <TableCell>Início</TableCell>
              <TableCell>Fim</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.id} hover>
                {user?.tipo_usuario === 'admin' && <TableCell>{item.empresa_id}</TableCell>}
                <TableCell>{item.imovel_numero ? `Unid. ${item.imovel_numero}` : 'N/A'}</TableCell>
                <TableCell>{item.pessoa_nome || 'N/A'}</TableCell>
                <TableCell>{item.pessoa_cpf || item.pessoa_rg || 'N/A'}</TableCell>
                <TableCell>{item.autorizador_nome || 'N/A'}</TableCell>
                <TableCell>{formatDate(item.data_inicio)}</TableCell>
                <TableCell>{formatDate(item.data_fim)}</TableCell>
                <TableCell>
                  <Chip size="small" color={situacaoColor(item.situacao)} label={situacaoLabel(item.situacao)} />
                </TableCell>
                <TableCell>
                  <IconButton aria-label="editar" onClick={() => onEdit(item)}>
                    <EditIcon />
                  </IconButton>
                  {item.ativo !== 0 && (
                    <IconButton aria-label="inativar" onClick={() => handleInativar(item.id)}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={user?.tipo_usuario === 'admin' ? 9 : 8} align="center">
                  Nenhum acesso liberado encontrado.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por página:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default AcessoLiberadoList;
